import MainMenu from './main-menu'

export default MainMenu
